import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Kids from "./pages/Kids";
import Fashion from "./pages/Fashion";
import ContactUs from "./pages/Contact";
import Groceries from "./pages/Groceries";
import ProductDetails from "./pages/ProductDetails";
import Checkout from "./pages/Checkout";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/kids" element={<Kids />} />
        <Route path="/fashion" element={<Fashion />} />
        <Route path="/groceries" element={<Groceries />} />
        <Route path="/contact" element={<ContactUs />} />
         <Route path="/product/:id" element={<ProductDetails />} />
         <Route path="/checkout" element={<Checkout />} />
      </Routes>
    </BrowserRouter>
  );
}


export default App;